import React, { useRef, useState } from 'react';

import "assets/scss/billingPortal/modules/reporting/invoiceCommission.scss";
import DrillDownReport from './reportTypes/DrillDownReport';
import MainReport from './reportTypes/MainReport';

export default function InvoiceCommission() {
    const [isDrillDownReportVisible, setIsDrillDownReportVisible] = useState();
    const [selectedSalesPersonDrillDown, setSelectedSalesPersonDrillDown] = useState();
    
    const queries = useRef({});

    return (
        <div>
            {isDrillDownReportVisible && (
            <div className={isDrillDownReportVisible? "":"d-none"}>
                <DrillDownReport queries={queries}
                    isDrillDownReportVisible={isDrillDownReportVisible}
                    setIsDrillDownReportVisible={setIsDrillDownReportVisible}
                    selectedSalesPersonDrillDown={selectedSalesPersonDrillDown}
                    setSelectedSalesPersonDrillDown={setSelectedSalesPersonDrillDown}
                />
            </div>
            )}

            <div className={isDrillDownReportVisible? "d-none":""}>
                <MainReport queries={queries}
                    setIsDrillDownReportVisible={setIsDrillDownReportVisible}
                    setSelectedSalesPersonDrillDown={setSelectedSalesPersonDrillDown}
                />
            </div>
        </div>
    );
}